import axios from 'axios';
import authHeader from './auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/scatter/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/scatter/';

class ScatterService {

  getAll() {
    return axios.get(API_URL+"all");
  }

  getScatterTeams(seasonIds, axisXColumnName, axisXStatTypeId, axisYColumnName, axisYStatTypeId, scatterPer90, limit){
    return axios.get(`${API_URL}team/seasons/${seasonIds}/x-axis-cn/${axisXColumnName}/x-axis-stId/${axisXStatTypeId}`+
      `/y-axis-cn/${axisYColumnName}/y-axis-stId/${axisYStatTypeId}/scatterPer90/${scatterPer90}/limit/${limit}`);

  }

  getScatterPlayers(seasonIds, fieldPositionIdsPlayed, minMinutes, maxAge, axisXStatId, axisYStatId, scatterPer90, bubbleSize, limit){
    return axios.get(`${API_URL}player/seasons/${seasonIds}/positions/${fieldPositionIdsPlayed}/min-minutes/${minMinutes}/max-age/${maxAge}` +
      `/x-axis-id/${axisXStatId}/y-axis-id/${axisYStatId}` +
      `/scatterPer90/${scatterPer90}/size/${bubbleSize}/limit/${limit}`);
  }

  getTeamMetrics(){
    return axios.get(`${API_URL}team-metrics`);

  }

  getPlayerMetrics(){
    return axios.get(`${API_URL}player-metrics`);
  }
}

export default new ScatterService();



// WEBPACK FOOTER //
// ./src/services/scatter.service.js